var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7041 21.8042C27.0363 21.0965 30.5887 17.6405 31.2157 13.0645C31.9854 7.4476 28.0559 2.27023 22.4389 1.50057C16.822 0.7309 11.6446 4.66039 10.875 10.2773C10.8479 10.4752 10.8266 10.6725 10.811 10.8691C6.4788 11.5767 2.92642 15.0328 2.29939 19.6087C1.52973 25.2257 5.45922 30.403 11.0762 31.1727C16.6931 31.9424 21.8705 28.0129 22.6401 22.3959C22.6672 22.1981 22.6885 22.0008 22.7041 21.8042Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape3.91f8dd9c26ea717f15e5a3687b2f6a14.svg";
export { ForwardRef as ReactComponent };